import { Store } from "pullstate";

export const CategoryStore = new Store({
    
    categories: [],
    hasLoaded: false
});